export const FLOW_NAME = "eta-estimator";
export type FLOW_TYPE = "eta-estimator";

export const INPUT_DATA = "data";

export const ORIGIN_LAT_KEY = "origin-lat";
export const ORIGIN_LONG_KEY = "origin-long";

export const DEST_LAT_KEY = "dest-lat";
export const DEST_LONG_KEY = "dest-long";

export const ORIGIN_LAT_LONG_KEY = "origin-lat-long";
export const DEST_LAT_LONG_KEY = "dest-lat-long";

export const START_TIME_KEY = "start-time";
export const END_TIME_KEY = "end-time";
export const DURATION_KEY = "duration";

export const TIME_RESOLUTION_KEY = "time-resolution";

export const ID_VARS_KEY = "id-vars";
export const GROUP_VARS_KEY = "group-vars";

export const USE_HISTORY_KEY = "use-history";
export const BUILD_GROUP_MODELS = "build-group-models";

export const RECIPE_NAME =
  "estimate-eta-based-on-origin-and-destination-co-ords";

export const ALGORITHMS = ["boosted-trees", "bayesian-nig"];

export const AUGMENTED_FILE = "augmented-data";
export const Y_NAME = "time-to-arrival";

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";
